export default "__VITE_ASSET__C5C$NNBC__"